import React, {useEffect, useState} from 'react'
import {FONT_FAMILY_LIST, FONT_NAME_LIST} from "../../../../common/constants/designer.constant";
import WebFontLoader from "webfontloader";
import SearchBox from "../../../../common/ui/search-box";
import _ from "lodash";

// const fontFamilyList = FONT_FAMILY_LIST;

const PreviewFontFamily = ({parentForm, handleFontDetailsChanges}) => {
    const [fontFamilyList, setFontFamilyList] = useState(FONT_FAMILY_LIST);
    const [showModal, setShowModal] = useState(false);
    const [selectedFont, setSelectedFont] = useState(null);
    const [selectedFontKey, setSelectedFontKey] = useState(null);
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        if (showModal) {
            WebFontLoader.load({
                custom: {
                    families: FONT_NAME_LIST
                }
            });
        }
    }, [showModal]);

    const handleConfirmAction = () => {
        const event = {
            target: {
                name: 'fontFamily',
                value: selectedFont,
                type: 'text'
            }
        };
        handleFontDetailsChanges(event, parentForm);
        setShowModal(false);
    }

    const handleCancelAction = () => {
        setShowModal(false);
    }

    const handleFontFamilyChange = (fontItem, origin) => {
        setSelectedFont(fontItem.fontName);
        setSelectedFontKey(fontItem.fontKey);
        scrollTo(fontItem, origin);
    }

    const scrollTo = (fontItem, origin) => {
        const destination = origin === 'card' ? 'menu' : 'card';
        const section = document.querySelector('#' + destination + '-' + fontItem.fontKey);
        section.scrollIntoView({behavior: 'smooth', block: 'center'});
    };

    useEffect(() => {
        prepareFilteredFontFamilyList();
    }, [searchText]);

    const prepareFilteredFontFamilyList = () => {
        let filteredFontFamilyList = [];

        _.forEach(FONT_FAMILY_LIST, fontItem => {
            if (searchText) {
                if (_.toLower(fontItem.fontName).indexOf(_.toLower(searchText)) !== -1) {
                    filteredFontFamilyList.push(fontItem);
                }
            } else {
                filteredFontFamilyList.push(fontItem);
            }
        });

        setFontFamilyList(filteredFontFamilyList);
    }


    return (
        <>
            <div className="flex items-center justify-center">
                <button
                    className="button-small-link"
                    onClick={() => setShowModal(true)}>
                    <span>Fonts</span>
                </button>
            </div>
            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-full my-6 mx-auto max-w-7xl">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex justify-center px-5 pt-6 rounded-t">
                                    <h3 className="text-3xl font-bold">
                                        <span className="text-blue-500">{selectedFont}</span>
                                        <span
                                            className={`pl-4 ${selectedFont ? 'text-family-' + selectedFontKey : ''}`}>Select A Font Family</span>
                                    </h3>
                                </div>
                                {/*body*/}
                                <div
                                    className="relative p-6">

                                    <div className="flex justify-center">
                                        <div className="-ml-2 -mt-4">
                                            <SearchBox
                                                label={'Search Fonts'}
                                                searchText={searchText}
                                                setSearchText={setSearchText}/>

                                        </div>
                                    </div>

                                    <div className="flex justify-center">

                                        <div
                                            className="w-1/3 justify-center content-start preview-font-family-section-container overflow-y-scroll border border-purple-600 rounded mr-4">
                                            {fontFamilyList?.map((fontItem, index) => (
                                                <div key={index}
                                                     id={`menu-${fontItem.fontKey}`}
                                                     className={`cursor-pointer px-2 py-1 w-full ${selectedFontKey === fontItem.fontKey ? 'font-family-card-selected' : ''}`}
                                                     onClick={() => {
                                                         handleFontFamilyChange(fontItem, 'menu')
                                                     }}>
                                                    <div>{fontItem?.fontName}</div>
                                                </div>
                                            ))}
                                        </div>

                                        <div
                                            className="flex flex-wrap w-full justify-center content-start preview-font-family-section-container overflow-y-scroll border border-purple-600 rounded">
                                            {fontFamilyList?.map((fontItem, index) => (
                                                <div key={index} className="m-2" id={`card-${fontItem.fontKey}`}>
                                                    <div>
                                                        <div
                                                            className='text-center text-sm text-purple-800'>{fontItem.fontName}</div>
                                                        <div className="flex justify-center">
                                                            <button
                                                                onClick={() => {
                                                                    handleFontFamilyChange(fontItem, 'card')
                                                                }}
                                                                className={`font-preview-card font-family-card ${selectedFontKey === fontItem.fontKey ? 'font-family-card-selected' : ''}`}>

                                                                <div className="">
                                                                    <div
                                                                        className={`text-center ${fontItem.fontKey ? 'text-family-' + fontItem?.fontKey : ''}`}
                                                                        dangerouslySetInnerHTML={{__html: 'Sample Text'}}></div>
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-center px-6 pb-6 rounded-b">
                                    <button
                                        className="text-gray-500 border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleCancelAction}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Selected Font
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default PreviewFontFamily
